import { render, staticRenderFns } from "./Signup-Teacher-1Step-New.vue?vue&type=template&id=f517831a&scoped=true"
import script from "./Signup-Teacher-1Step-New.vue?vue&type=script&lang=js"
export * from "./Signup-Teacher-1Step-New.vue?vue&type=script&lang=js"
import style0 from "./Signup-Teacher-1Step-New.vue?vue&type=style&index=0&id=f517831a&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f517831a",
  null
  
)

export default component.exports